import React from 'react';
import { Input } from 'antd';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import cn from 'classnames';

import './style.scss';

const NumberInput = ({
  thousandSeparator,
  decimalSeparator,
  decimalScale,
  prefix,
  allowNegative = false,
  ...rest
}) => {
  return (
    <div id="my-input">
      {prefix && (
        <div className="number-input-prefix-custom">
          <span>{prefix}</span>
        </div>
      )}
      <NumberFormat
        {...rest}
        allowNegative={allowNegative}
        className={cn('input-custom', { 'has-prefix': !!prefix })}
        customInput={Input}
        thousandSeparator={thousandSeparator}
        decimalSeparator={decimalSeparator}
        decimalScale={decimalScale}
      />
    </div>
  );
};

NumberInput.propTypes = {
  thousandSeparator: PropTypes.bool,
  decimalSeparator: PropTypes.string,
  decimalScale: PropTypes.number,
};

NumberInput.defaultProps = {
  thousandSeparator: true,
  decimalSeparator: '.',
  decimalScale: 2,
};

export default NumberInput;
